/**
 * Schedule input helpers — round-trip between the browser's
 * `datetime-local` input format and ISO-8601 UTC strings the API expects.
 *
 * Shared by ProductScheduleModal + AnnouncementEditModal because both
 * use the same `launch_at` / `archive_at` pattern.
 */
export const toLocalInput = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch {
    return "";
  }
};

export const fromLocalInput = (s) => (s ? new Date(s).toISOString() : "");
